import { BaseComponent } from './base.component';
import { Directive, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { BaseFormComponent } from './base-form.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive()
export abstract class BaseModalComponent<T = null, F extends BaseFormComponent<T> = null> extends BaseComponent {

  @ViewChild(ModalComponent) modalComponent: ModalComponent;
  @ViewChild('formComponent') formComponent: F;

  @Input() title: string;

  @Output() onOpen = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<void>();
  @Output() formFinished = new EventEmitter<any>();

  public data: T;

  public open(val?: T): void {
    this.data = val;
    this.onOpen.emit();
    this.modalComponent.open();
    this.cdr.detectChanges();

    if (this.formComponent) {
      setTimeout(() => {
        this.formComponent.formFinished
          .pipe(
            takeUntilDestroyed(this.formComponent.destroyRef)
          )
          .subscribe(val => {
            this.close();
            this.formFinished.emit(val);
          });

        this.formComponent.submitting
          .pipe(
            takeUntilDestroyed(this.formComponent.destroyRef)
          )
          .subscribe(() => this.cdr.detectChanges());
      });
    }
  }

  public close(): void {
    this.data = null;
    this.onClose.emit();
    this.modalComponent.close();
    this.cdr.detectChanges();
  }

  public submitForm(): void {
    this.formComponent?.onSubmit();
  }

  public get isFormSubmitting(): boolean {
    return this.formComponent?.isSubmitting;
  }
}
